module.exports = __webpack_public_path__ + "static/media/portrait@2x.ee4127f1.webp";